<!-- eslint-disable -->
<template>

  <datepicker-single
    :block="block"
    id="singleDatePicker"
    :onFocusChange="onFocusChange"
    :onDateChange="onDatesChange"
    :numberOfMonths="numberOfMonths"
    :focused="focusedInput"
    :disabled="disabled"
    :date="date"
    :appendToBody="appendToBody"
    :displayFormat="displayFormat"
    :isOutsideRange="isOutsideRange"
    :monthFormat="monthFormat"
    :placeholder="placeholder"
    :showClearDate="showClearDate"
  /> 
</template>

<script>
import { ReactInVue } from './vuera'
import './react-dates/initialize'

import moment from 'moment'
import { SingleDatePicker, isInclusivelyAfterDay } from './react-dates'
function isValidDate(date) {
  return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date) && date instanceof Date
}
export default {
  name: 'MAGDatepickerSingle',
  components: {
    'datepicker-single': ReactInVue(SingleDatePicker)
  },
  props: {
    block:{
      default: false,
      type: Boolean
    },
    displayFormat: {
      default: '',
      type: String
    },
    showClearDate:{
      default: true,
      type: Boolean
    },
    placeholder:{
      default: 'Date',
      type: String
    },
    monthFormat: {
      default: 'MMMM YY',
      type: String
    },
    initialStartDate: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    numberOfMonths: {
      default: 1,
      type: Number
    },
    selectableRanges: {
      default: () => [],
      type: Array
    },
    dateRangeFormat: {
      default: null
    },
    appendToBody: {
      default: false,
      type: Boolean
    }
  },
  data () {
      var date = isValidDate(this.initialStartDate) ? moment(this.initialStartDate) : null
    return {
      date,
      focusedInput: false,
      isOutsideRange: () => false
    }
  },
  mounted () {

    if (this.selectableRanges.length > 0) {
      this.isOutsideRange = (day) => {
        for (let selectedRangeIndex = 0; selectedRangeIndex < this.selectableRanges.length; selectedRangeIndex++) {
          var rangeStart = this.selectableRanges[selectedRangeIndex][0]
          var rangeEnd = this.selectableRanges[selectedRangeIndex][1]
          if (!isInclusivelyAfterDay(day, moment(rangeStart, this.dateRangeFormat)) || isInclusivelyAfterDay(day, moment(rangeEnd, this.dateRangeFormat))) continue
          else return false
        }
        return true
      }
    }
  },
  methods: {
    onDatesChange: function (date) {
      this.date = date
      this.$emit('date-changed', moment(date))
    },
    onFocusChange: function ({ focused }) {
      this.focusedInput = focused
      this.$emit('input-field-toggled', focused)
    }
  }
}

</script>

<style lang="scss">
@import './react-dates/lib/css/_datepicker.css';
.DayPicker__hidden{
    visibility: visible;
}
.DateRangePicker_picker {
    z-index: 2000;
}
</style>
